<svelte:options tag="app-cookie-consent" />

<div id="cookie-consent">
  <app-banner menuexpanded="true" level="info" {text} {linktext} {linkurl}>
    <span slot="dismiss">
      <!-- should be replaced with Button component later -->
      <button id="close-cookie-consent">Accept</button>
    </span>
  </app-banner>
</div>

<script>
  import { onMount } from 'svelte'
  import { get_current_component } from 'svelte/internal'

  export let text =
    "The RIPE NCC uses cookies. Some of these cookies may have been set already. More information about our cookies can be found in our Privacy Policy. You can accept our cookies either by clicking on the 'Accept' button or by continuing to use the site."
  export let linktext = 'privacy policy'
  export let linkurl = 'https://www.ripe.net/about-us/legal/ripe-ncc-privacy-statement#cookies'

  const component = get_current_component()
  const cookieName = 'cookies-accepted'
  onMount(async () => {
    const cookie = readCookie(cookieName)
    if (cookie) {
      component.$destroy()
      return false
    }

    component.addEventListener('app-banner-closed', e => {
      setCookie(cookieName)
      component.$destroy()
    })
  })

  const readCookie = name => {
    return (document.cookie.match(`(^|; )${name}=([^;]*)`) || 0)[2]
  }

  const setCookie = name => {
    const age = 24 * 60 * 60 * 365
    document.cookie = `${name}=accepted; max-age=${age}; domain=.ripe.net; path=/`
  }
</script>

<style type="text/scss">
  @import '../shared/color-themes';

  #close-cookie-consent {
    padding: 8px;
    color: white;
    background-color: var(--ripe-app-nav-rail-tooltip-bg, #363738);
    font-weight: bold;
    border-width: 0;
    border-radius: 2px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
    cursor: pointer;
  }
</style>
